import {Component, OnInit} from '@angular/core';
import {CollectionsService} from '../../../collections/service/collections.service';

@Component({
  selector: 'app-highlights',
  templateUrl: './highlights.component.html',
  styleUrls: ['./highlights.component.scss']
})
export class HighlightsComponent implements OnInit {

  highlightCollections: any;

  constructor(public collectionsService: CollectionsService) {
  }

  ngOnInit(): void {
    // this.highlightCollections = this.collectionsService.getHighlights();
  }
}
